// extracted by mini-css-extract-plugin
module.exports = {"usualNavItem":"styles_usualNavItem__8dSK_","iconSlot":"styles_iconSlot__PH1D_"};